import { render } from "./TableUi.vue?vue&type=template&id=a017bac8"
import script from "./TableUi.vue?vue&type=script&lang=js"
export * from "./TableUi.vue?vue&type=script&lang=js"

import "./TableUi.vue?vue&type=style&index=0&id=a017bac8&lang=scss"
script.render = render

export default script